import { AlertModal, Button, TextBlock } from "@bcc-ui/ui-components";
import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./file-sharing.scss";

import testIds from "testIds.json";

interface Props {
    error: string;
    headingText: string;
    onClose: () => void;
}

const FileSharingErrorDialog = ({ error, headingText, onClose }: Props): JSX.Element => {
    const { t } = useTranslation();
    return (
        <AlertModal
            title={headingText}
            variant="Error"
            isOpen={true}
            hideModal={onClose}
            className={style.dialog}
            buttons={
                <Button variant="Secondary" onClick={onClose} testId={testIds.common.dialog.closeButton}>
                    {t("Common.close")}
                </Button>
            }
        >
            <TextBlock>{error}</TextBlock>
        </AlertModal>
    );
};

export default FileSharingErrorDialog;
